export const sendBroadCast = (channel, message) => {
    const broadcastChannel = new BroadcastChannel(channel);
    broadcastChannel.postMessage({ action: message });
    // localStorage.clear();
}



export const logOutBroadCast = () => {
    const broadcastChannel = new BroadcastChannel('logoutChannel');
    broadcastChannel.onmessage = (event) => {
        if (event.data.action === 'logout') {
            window.location.href = '/';
        }
    };

}

// 
export const setCurrentNotification = (details) => {
    localStorage.setItem("currentNotification", JSON.stringify(details));
}
export const getCurrentNotification = () => {
    return JSON.parse(localStorage.getItem("currentNotification"))
}

export const getDateOnly = (date) => {
    const isoString = new Date(date).toISOString();
    const dateOnly = isoString.slice(0, 10);

    return dateOnly;
};
export const getTimeOnly = (date) => {
    const isoString = new Date(date).toISOString();
    const timeOnly = isoString.slice(11, 19);

    return timeOnly;
};

export const formatNotificationTime = (notificationTime) => {
    const currentTime = new Date();
    const notificationDate = new Date(notificationTime);

    const timeDifference = currentTime - notificationDate;
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) {
        return `${seconds} seconds ago`;
    } else if (minutes < 60) {
        return `${minutes} minutes ago`;
    } else if (hours < 24) {
        return `${hours} hours ago`;
    } else if (days === 1) {
        return `${days} day ago`;
    } else {
        return `${days} days ago`;
    }
};
